import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import PracticeAreas from "../components/PracticeAreas";
import DismissalDeadlineCalculator from "../components/DismissalDeadlineCalculator";
import DismissalRiskAssessment from "../components/DismissalRiskAssessment";
import ArticlesSection from "../components/ArticlesSection";
import FaqSection from "../components/FaqSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import { useSEO } from "../lib/seo";

export default function HomePage() {
    useSEO({
        title: null,
        description: "Avv. Marco Candido — Studio Legale specializzato in diritto del lavoro. Licenziamenti, mobbing, vertenze, contratti, conciliazioni. Sedi a Piacenza, Milano e Lecce.",
        path: "/",
    });
    return (
        <div data-testid="homepage">
            <Header />
            <main>
                <Hero />
                <About />
                <PracticeAreas />
                <DismissalDeadlineCalculator />
                <DismissalRiskAssessment />
                <ArticlesSection />
                <FaqSection />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
